import { FormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-validar-data[form][campo]',
  template: `
  <ng-container
    *ngIf="form.controls[campo].hasError('dataErro') &&
    (form.controls[campo].dirty ||
    form.controls[campo].touched)
  ">
    Data inválida
  </ng-container>`
})
export class ValidarDataComponent {

  @Input() campo: string;
  @Input() nome: string;
  @Input() form: FormGroup;

}
